/** Top chrome for the reseller/commercial partner console.
 *
 * Mirrors the customer-app TopBar (brand, locale switcher, sign-out) but
 * drops the org switcher + search (partner users have no org). This is
 * where the language switch + LOGOUT live for the partner surface.
 */
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { useLogout } from "@/lib/auth";
import { usePartnerMe } from "@/lib/partner";

import { LocaleSwitcher } from "./LocaleSwitcher";

export function PartnerTopBar() {
  const { t } = useTranslation();
  const logout = useLogout();
  const navigate = useNavigate();
  const me = usePartnerMe();

  return (
    <header className="sticky top-0 z-40 border-b border-nb-border bg-nb-bg/80 backdrop-blur">
      <div className="mx-auto flex max-w-screen-2xl 2xl:max-w-[105rem] items-center justify-between px-6 py-3">
        <div className="flex items-center gap-3">
          <Link
            to="/partner"
            className="font-semibold tracking-tight text-nb-text"
          >
            Nex<span className="text-nb-mint">.</span>Basira
            <span className="text-nb-mint">/</span>
          </Link>
          <span className="rounded-md bg-nb-mint/15 px-2 py-1 text-xs font-semibold uppercase tracking-wide text-nb-mint">
            {t("partner.badge")}
          </span>
        </div>
        <div className="flex items-center gap-3 text-sm text-nb-text">
          {me.data && (
            <span className="hidden text-nb-text-2 sm:inline">
              {me.data.name}
            </span>
          )}
          <LocaleSwitcher />
          <button
            className="inline-flex items-center gap-1.5 rounded-md border border-nb-border px-3 py-1.5 text-sm font-medium text-nb-text-2 transition hover:border-nb-danger/60 hover:bg-nb-danger/10 hover:text-nb-danger"
            onClick={() => {
              logout.mutate(undefined, {
                onSettled: () => navigate("/login", { replace: true }),
              });
            }}
            title={t("auth.signOut")}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{t("auth.signOut")}</span>
          </button>
        </div>
      </div>
    </header>
  );
}
